import util from '../util';

export const WIDGET_CONFIG = 'WIDGET_CONFIG';
export const WIDGET_CONFIG_PREVIEW = 'WIDGET_CONFIG_PREVIEW';
export const UPDATE_WIDGET_CONFIG = 'UPDATE_WIDGET_CONFIG';

export const WIDGET_CONFIG_REQUEST = util.requestType(WIDGET_CONFIG);
export const WIDGET_CONFIG_SUCCESS = util.successType(WIDGET_CONFIG);
export const WIDGET_CONFIG_FAILURE = util.failureType(WIDGET_CONFIG);

export const WIDGET_CONFIG_PREVIEW_REQUEST = util.requestType(
  WIDGET_CONFIG_PREVIEW,
);
export const WIDGET_CONFIG_PREVIEW_SUCCESS = util.successType(
  WIDGET_CONFIG_PREVIEW,
);
export const WIDGET_CONFIG_PREVIEW_FAILURE = util.failureType(
  WIDGET_CONFIG_PREVIEW,
);

export const UPDATE_WIDGET_CONFIG_REQUEST =
  util.requestType(UPDATE_WIDGET_CONFIG);
export const UPDATE_WIDGET_CONFIG_SUCCESS =
  util.successType(UPDATE_WIDGET_CONFIG);
export const UPDATE_WIDGET_CONFIG_FAILURE =
  util.failureType(UPDATE_WIDGET_CONFIG);
